/**
 * 🎨 Container Edit Controls
 * 
 * Edit-Button für hero-content-wrapper Container
 * - Erscheint rechts oben beim Hover
 * - Öffnet ContainerFloatingToolbar
 * - Nur im Edit Mode sichtbar
 */

import React from 'react';
import './ContainerEditControls.css';

function ContainerEditControls({ 
    isEditMode,
    isToolbarVisible,
    onEdit
}) {
    if (!isEditMode) {
        return null;
    }

    return (
        <div className="container-edit-controls">
            <button
                className={`container-edit-btn ${isToolbarVisible ? 'active' : ''}`}
                onClick={(e) => {
                    e.stopPropagation();
                    if (onEdit) {
                        onEdit();
                    }
                }}
                title="Edit Container"
            >
                <i className="fas fa-sliders-h"></i>
                <p>Edit</p>
            </button>
        </div>
    );
}

export default ContainerEditControls;

